import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card } from 'antd';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import home1 from '../../static/home1.webp';
import banner1 from '../../static/banner1.png';
import banner2 from '../../static/banner2.png';
import banner3 from '../../static/banner3.png';

const stats = [
  { value: '850+', label: '线上陪伴社群' },
  { value: '300+', label: '覆盖城市' },
  { value: '10万+', label: '郁友及家属' },
  { value: '3500+', label: '爱心志愿者' },
  { value: '5000+', label: '线下活动' },
  { value: '5000篇+', label: '科普文章' },
  { value: '50万册+', label: '科普手册发放' },
  { value: '1000万+', label: '科普受益人群' },
];

const services = [
  {
    icon: '📢',
    title: '科普宣传',
    desc: '20+自媒体矩阵，粉丝超80万。公众号发布科普文章超5000篇，让更多人找到组织和希望。',
  },
  {
    icon: '🏘️',
    title: '社群支持',
    desc: '全国34省300+城市，850+线上陪伴社群，聚集郁友与家属共同支持，举办线下活动超5000场。',
  },
  {
    icon: '💬',
    title: '倾听陪伴',
    desc: '300+经系统培训的郁金香陪伴者，以公益价格提供专业陪伴及咨询，惠及20000人次。',
  },
  {
    icon: '🌱',
    title: '成长学苑',
    desc: '40+特色疗愈社群，含绘画、正念冥想、八段锦等。家长成长学堂惠及家庭超15000个。',
  },
  {
    icon: '📚',
    title: '读物科普',
    desc: '编发《回到人间》系列丛书、《抑郁科普知识200问》等，联合三联书店出版科普读物。',
  },
  {
    icon: '🎤',
    title: '讲座论坛',
    desc: '主办无郁中国行城市讲座、全国青少年心理健康论坛，独创"920郁友节"，论坛超20次。',
  },
  {
    icon: '👩‍⚕️',
    title: '专家课程',
    desc: '特聘医学/心理专家超50位，推出音视频课程、特色工作坊和疗愈产品，帮助郁友获得力量。',
  },
  {
    icon: '🏠',
    title: '郁金香暖屋',
    desc: '与绿城爱心基金会联合打造社区15分钟心理健康服务圈，构建网格化心理健康服务体系。',
  },
];

const philosophy = [
  {
    label: '疗愈理念',
    title: '生物 · 心理 · 社会',
    desc: '解构抑郁发生的常见原理与脉络，融合生物、心理、社会三维度，创建综合疗愈体系。',
    cls: 'philosophy-card--primary',
  },
  {
    label: '康复路线',
    title: '觉醒 · 疗愈 · 回归',
    desc: '联结纵向康复点与横向康复链，形成网格化疗愈体系，对个体“痛点难点堵点”综合评估。',
    cls: 'philosophy-card--dark',
  },
];

const honors = [
  '多次获央视、凤凰卫视、学习强国等20+权威媒体表彰',
  '荣获年度全国心理行业影响力评选第一名',
  '连续五年荣获杭州市"春风行动二十年"美好奖',
  '"无郁中国行"荣获第七届中国公益事业大典优秀项目奖',
  '成功危机干预超300起',
  '郁友康复故事超1000个',
];

const sceneCards = [
  {
    image: banner1,
    alt: '郁金香陪伴行动现场图1',
    title: '郁金香陪伴行动介绍',
    desc: '展示组织核心定位与长期行动方向。',
  },
  {
    image: banner2,
    alt: '郁金香陪伴行动现场图2',
    title: '网格化疗愈体系',
    desc: '围绕“生物-心理-社会”与“觉醒-疗愈-回归”，形成纵横交织的康复支持网络。',
  },
  {
    image: banner3,
    alt: '郁金香陪伴行动现场图3',
    title: '多场景支持与服务',
    desc: '覆盖科普、社群、陪伴者、课程、论坛与社区服务，构建持续支持闭环。',
  },
];

const keyActions = [
  '主办无郁中国行城市讲座、全国青少年心理成长论坛等主题论坛 20+ 次',
  '独创“920郁友节”，让郁友拥有自己的节日与公开表达空间',
  '线上线下联动开展知识科普、康复支持、家庭成长和危机干预',
  '联合多方资源探索社区心理健康服务站点与15分钟心理服务圈',
];

const mediaHighlights = [
  {
    title: '媒体矩阵传播',
    desc: '公众号、视频号、微博、抖音、快手、B站等20+平台联动，持续进行心理健康科普。',
  },
  {
    title: '出版与读物',
    desc: '编发《回到人间》系列丛书与《抑郁科普知识200问》，联合三联书店推出公益读物。',
  },
  {
    title: '公开表达与倡导',
    desc: '通过论坛、讲座、康复案例与节日倡导，推动“抑郁可被理解、可被帮助、可逐步康复”的社会共识。',
  },
];

const joinWays = [
  '加入志愿者团队，参与郁友陪伴与公益活动支持',
  '提供企业岗位或资源合作，助力康复回归社会',
  '关注公众号，持续获取科学科普与服务入口',
];

const storyCards = [
  {
    title: '家长成长学堂：共同成长实践',
    desc: '围绕“家长改变 1%，孩子成长 99%”的理念，持续支持家庭在康复中建立稳定陪伴关系。',
    link: 'http://mp.weixin.qq.com/s?__biz=MzIzODM3NzMxOQ==&mid=2247594353&idx=2&sn=df6a07ec8f8fdf9bbfdddf1ee45424d2&chksm=e9397179de4ef86f0f03d7ce0f50d5e95b36afc62fe56e6db2ef88dbe68e3f56270f0db455f&scene=21#wechat_redirect',
  },
  {
    title: '城市陪伴网络：持续招募与共建',
    desc: '城市郁金香陪伴长持续招募中，面向更多城市建立在地化支持网络与社群联动。',
    link: 'http://mp.weixin.qq.com/s?__biz=MzIzODM3NzMxOQ==&mid=2247591186&idx=1&sn=976b1efd4c70cca895b7cfb9ad9e9305&chksm=e939651ade4eec0ce8af5b289c536ec15c0ba5fe0db10a16445af70f5adcd68819fed58bb853&scene=21#wechat_redirect',
  },
  {
    title: '特色疗愈社群：加入成长共修',
    desc: '朗读、绘画、写作、正念、舞动等多样社群活动，支持成员持续练习与复原。',
    link: 'http://mp.weixin.qq.com/s?__biz=MzIzODM3NzMxOQ==&mid=2247584238&idx=1&sn=f35ccf731c6d36783797066e0b711474&chksm=e93989e6de4e00f05308ac498657b25e92e060d46c2acda7ae59e1a541d3a51acbe4830ce1da&scene=21#wechat_redirect',
  },
];

const Home: React.FC = () => {
  const history = useHistory();
  return (
    <PageLayout history={history} children={[]} Content={
      <div className="home-page">

        {/* ===== Hero Banner ===== */}
        <section className="home-hero">
          <img className="home-hero__bg-img" src={home1} alt="郁金香陪伴活动" />
          <div className="home-hero__overlay" />
          <div className="home-hero__content">
            {/* <div className="home-hero__tag">中国抗郁行动引领者 · 2014年发起</div> */}
            <h1 className="home-hero__title">郁金香陪伴</h1>
            <p className="home-hero__sub">
              遵循"生物-心理-社会"综合疗愈理念<br />践行"觉醒-疗愈-回归"康复行动路线
            </p>
            <div className="home-hero__cta">
              <button className="btn-primary" onClick={() => history.push('/foundation-intro')}>了解我们</button>
              <button className="btn-ghost" onClick={() => history.push('/board-members')}>理事会成员</button>
            </div>
          </div>
        </section>

        {/* ===== Stats ===== */}
        <section className="home-stats">
          <div className="section-inner">
            <div className="home-stats__label">10年耕耘，星光闪耀</div>
            <Row gutter={[24, 24]}>
              {stats.map((s) => (
                <Col xs={12} sm={6} md={3} key={s.label}>
                  <div className="home-stats__item">
                    <span className="home-stats__value">{s.value}</span>
                    <span className="home-stats__desc">{s.label}</span>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* ===== Philosophy ===== */}
        <section className="home-philosophy">
          <div className="section-inner">
            <h2 className="home-section-title">核心理念</h2>
            <Row gutter={[32, 24]}>
              {philosophy.map((p) => (
                <Col xs={24} md={12} key={p.title}>
                  <div className={`philosophy-card ${p.cls}`}>
                    <div className="philosophy-card__label">{p.label}</div>
                    <h3 className="philosophy-card__title">{p.title}</h3>
                    <p className="philosophy-card__desc">{p.desc}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* ===== Services ===== */}
        <section className="home-services">
          <div className="section-inner">
            <h2 className="home-section-title">我们的服务</h2>
            <Row gutter={[24, 24]}>
              {services.map((srv) => (
                <Col xs={24} sm={12} md={6} key={srv.title}>
                  <Card className="service-card" bordered={false}>
                    <div className="service-card__icon">{srv.icon}</div>
                    <h3 className="service-card__title">{srv.title}</h3>
                    <p className="service-card__desc">{srv.desc}</p>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* ===== Honors ===== */}
        <section className="home-honors">
          <div className="section-inner">
            <h2 className="home-section-title">荣誉与成就</h2>
            <Row gutter={[16, 16]}>
              {honors.map((h) => (
                <Col xs={24} sm={12} md={8} key={h}>
                  <div className="honor-item">
                    <span className="honor-item__dot">✦</span>
                    <span>{h}</span>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* ===== Action Scenes ===== */}
        <section className="home-scenes">
          <div className="section-inner">
            <h2 className="home-section-title">行动现场</h2>
            <Row gutter={[20, 20]}>
              {sceneCards.map((item) => (
                <Col xs={24} md={8} key={item.title}>
                  <article className="scene-card">
                    <img className="scene-card__img" src={item.image} alt={item.alt} />
                    <div className="scene-card__overlay" />
                    <div className="scene-card__content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </article>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* ===== Stories ===== */}
        <section className="home-stories">
          <div className="section-inner">
            <h2 className="home-section-title">康复故事与成长案例</h2>
            <Row gutter={[20, 20]}>
              {storyCards.map((item) => (
                <Col xs={24} md={8} key={item.title}>
                  <article className="story-card">
                    <h3>{item.title}</h3>
                    <p>{item.desc}</p>
                    <a href={item.link} target="_blank" rel="noreferrer">阅读文章</a>
                  </article>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* ===== Key Actions ===== */}
        <section className="home-actions">
          <div className="section-inner home-actions__inner">
            <div className="home-actions__left">
              <h2 className="home-section-title">重点行动</h2>
              <p className="home-actions__intro">
                组织已形成"科普-支持-陪伴-成长"闭环，持续推进社会心理健康公益行动。
              </p>
            </div>
            <ul className="home-actions__list">
              {keyActions.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* ===== Media ===== */}
        <section className="home-media">
          <div className="section-inner">
            <h2 className="home-section-title">传播与出版</h2>
            <Row gutter={[20, 20]}>
              {mediaHighlights.map((item) => (
                <Col xs={24} md={8} key={item.title}>
                  <article className="media-card">
                    <h3>{item.title}</h3>
                    <p>{item.desc}</p>
                  </article>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* ===== Join ===== */}
        <section className="home-join">
          <div className="section-inner home-join__inner">
            <div className="home-join__main">
              <h2>欢迎与郁金香同行</h2>
              <p>
                如果你还在抑郁中挣扎，请伸出手。这里有理解、接纳与方法；如果你愿意帮助他人，也欢迎加入我们，一起把支持带到更多人身边。
              </p>
              <ul>
                {joinWays.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="home-join__cta">
                <button className="btn-primary" onClick={() => history.push('/contact')}>联系我们</button>
                <button className="btn-ghost" onClick={() => history.push('/partners')}>合作伙伴</button>
              </div>
            </div>
          </div>
        </section>

        {/* ===== Mission ===== */}
        <section className="home-mission">
          <div className="section-inner home-mission__inner">
            <div className="home-mission__text">
              <h2 className="home-section-title home-section-title--light">关于郁金香陪伴</h2>
              <p>
                郁金香陪伴由爱心人士爱咪女士于2014年10月发起，致力于搭建"心理健康、抑郁帮扶"的爱心互助平台。专注抑郁康复、心理健康，通过康复监测、心理疗愈、文体活动、关爱帮助、家庭支持等多种方式，陪伴与助力抑郁康复之路。
              </p>
              <p>
                这里汇聚着各方爱心的支持，这里拥有足够的理解和接纳，这里聚集了众多康复的方法与路径，这里还有许多康复者榜样的力量。
              </p>
              <p className="home-mission__quote">
                抗击抑郁，你不是一个人在战斗。
              </p>
              <div className="home-mission__cta">
                <button className="btn-primary-dark" onClick={() => history.push('/foundation-intro')}>深入了解</button>
              </div>
            </div>
          </div>
        </section>

      </div>
    } />
  );
};

export default Home;

